import { HeroLayout } from "@bridgetool/gatsby-theme-dev/src/components/ThemeComponents";
import * as React from 'react';
export default {
  HeroLayout,
  React
};